import React from 'react';
import eco_spinner from 'images/spinner/eco_spinner.gif';

const Loader = () => {
    return (
        <>
            <img style={{ height: 50 }} src={eco_spinner} />
        </>
    );
};

export default Loader;
